import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Ai in market research',
                topics: [
                    'Unlocking Customer Insights: Leveraging AI for Big Data Analytics in Market Research',
                    'Identify the Trends: the Power of Predictive Analytics with AI in Market Research',
                    'Revolutionizing Market Research: AI-Powered Social Listening',
                    'Straight to the point: AI-Based Customer Segmentation for Market Research and Targeting',
                ],
            },
            {
                title: 'AI in content marketing',
                topics: [
                    'Transforming Email Marketing: Harnessing the Power of AI for Personalization and Optimization',
                    'Accelerating Content Creation: The Power of AI in Content Marketing',
                    'Maximizing Engagement: Social Media Marketing with AI-Generated Content',
                    'Tools: GPT chat, Lately, Clearscope, Acrolinx, Persado, Zest AI, Wordsmith, Cortex',
                ],
            },
            {
                title: 'AI in Marketing Analytics',
                topics: [
                    'Unleashing the Power of AI: Analyzing Customer Behavior and Enhancing User Experience',
                    'Making Informed Decisions: AI-Driven Marketing Attribution and Optimization',
                    'From Insights to Action: Leveraging AI for Real-Time Campaign Management',
                    'Beyond Traditional Metrics: AI-Based Predictive Analytics for Sales and Revenue Optimization',
                ],
            },
            {
                title: 'Challenges of AI',
                topics: [
                    'AI How to choose the right AI tool for your business',
                    'Overcoming Data Limitations: Addressing Data Quality and Privacy Concerns in AI-Driven Marketing',
                    'Navigating the Technical Landscape: Addressing Integration and Compatibility Issues with AI Marketing Tools',
                    'Scalability: Ensuring that AI models can scale to meet the demands of growing businesses and user bases',
                ],
            },
            {
                title: 'AI in customer care',
                topics: [
                    'Enhancing Customer Experience: Leveraging AI-Powered Chatbots and Virtual Assistants',
                    'Addressing Customer Needs: AI-Driven Personalization and Recommendation Engines in Customer Service',
                    'Multilingual Support: Breaking Down Language Barriers with AI Translation and Localization in Customer Service',
                    'Measuring Success: Utilizing Metrics and Analytics to Evaluate the Performance of AI in Customer Service',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;